import { Commit } from "vuex";
import { Axios } from "axios";
import { PermCatalogRow, PermDetail, PermisosState, UserRow } from "./state";

function cleanParams(obj: any) {
  const out: any = {};
  Object.keys(obj || {}).forEach((k) => {
    const v = obj[k];
    if (v !== null && v !== undefined && String(v).trim() !== "") out[k] = v;
  });
  return out;
}

export default {
  async getPermsCatalog(
    { commit }: { commit: Commit },
    { axios, apiRoute }: { axios: Axios; apiRoute: string }
  ) {
    const token = localStorage.getItem("authToken");
    commit("setLoadingPerms", true);
    commit("setErrorMessage", null);

    try {
      const res = await axios.get(`${apiRoute}/permisos`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const rows = (res.data?.data ?? []) as PermCatalogRow[];
      const names = rows.map((r) => String(r.name)).sort((a, b) => a.localeCompare(b));

      commit("setPermsCatalog", names);
    } catch (err: any) {
      commit("setPermsCatalog", []);
      commit(
        "setErrorMessage",
        err?.response?.data?.message || "No se pudo cargar el catálogo de permisos."
      );
      console.error(err);
    } finally {
      commit("setLoadingPerms", false);
    }
  },

  async getUsers(
    { commit }: { commit: Commit },
    {
      axios,
      apiRoute,
      q = "",
    }: { axios: Axios; apiRoute: string; q?: string }
  ) {
    const token = localStorage.getItem("authToken");
    commit("setLoadingUsers", true);
    commit("setErrorMessage", null);

    try {
      const params = cleanParams({ q });
      const res = await axios.get(`${apiRoute}/usuarios`, {
        params,
        headers: { Authorization: `Bearer ${token}` },
      });

      const users = (res.data?.data ?? []) as UserRow[];
      commit("setUsers", users);
    } catch (err: any) {
      commit("setUsers", []);
      commit(
        "setErrorMessage",
        err?.response?.data?.message || "No se pudo cargar usuarios."
      );
      console.error(err);
    } finally {
      commit("setLoadingUsers", false);
    }
  },

  async getUserDetail(
    { commit }: { commit: Commit },
    { axios, apiRoute, userId }: { axios: Axios; apiRoute: string; userId: number }
  ) {
    const token = localStorage.getItem("authToken");
    commit("setLoadingDetail", true);
    commit("setErrorMessage", null);

    try {
      const res = await axios.get(`${apiRoute}/usuarios/${userId}/permisos`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const detail = res.data?.data as PermDetail;
      commit("setDetail", detail);
    } catch (err: any) {
      commit("setDetail", null);
      commit(
        "setErrorMessage",
        err?.response?.data?.message || "No se pudo cargar el detalle del usuario."
      );
      console.error(err);
    } finally {
      commit("setLoadingDetail", false);
    }
  },

  async saveUserDirectPerms(
    { commit, dispatch }: { commit: Commit; dispatch: any },
    {
      axios,
      apiRoute,
      userId,
      permissions,
    }: {
      axios: Axios;
      apiRoute: string;
      userId: number;
      permissions: string[];
    }
  ) {
    const token = localStorage.getItem("authToken");
    commit("setSaving", true);
    commit("setErrorMessage", null);

    try {
      await axios.put(
        `${apiRoute}/usuarios/${userId}/permisos`,
        { permissions },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      // recarga detalle para refrescar directos + efectivos
      await dispatch("getUserDetail", { axios, apiRoute, userId });
    } catch (err: any) {
      commit(
        "setErrorMessage",
        err?.response?.data?.message || "No se pudo guardar permisos."
      );
      console.error(err);
      throw err;
    } finally {
      commit("setSaving", false);
    }
  },
};